export default "__VITE_ASSET__CDXMNmnf__"